module.exports = __webpack_public_path__ + "img/2.bb5d97a3.png";